import { sendGetML, sendPostML } from "src/utils/sendApi";

export const fetchSmileSummary = sendPostML("smiles_new_flow");

export const fetchSmileResults = sendPostML("get_smiles_results");

export const fetchSmilesHistory = sendGetML("get_smiles_experiments");

export const deleteSmilesHistory = sendPostML("delete_smiles_experiments");